import React from 'react';
import {ColorWhite} from 'src/styles/Colors';
import {RadiusView} from 'src/res/Radius';
import {FontWeightMedium} from 'src/res/FontWeight';
import {SpaceNormal} from 'src/res/Spacing';
import CardFlipView from "./CardFlipView";
import AppImageButtonEx from "../commons/AppImageButtonEx";
import {locString} from "../commons/ViewHelper";
import View from "../commons/View";
import TouchableOpacity from "../commons/TouchableOpacity";
import ImageBackground from "../commons/ImageBackground";
import AppImage from "../commons/AppImage";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppUtils, {dispatchSimulationClick} from "../../utils/AppUtils";
import GameAudio from "../commons/GameAudio";
import {
  GAME_CARD_SHUFFLE_AUDIO,
  GAME_LOSE_AUDIO,
  GAME_NEUTRAL_AUDIO,
  GAME_PLAY_AUDIO,
  GAME_WIN_AUDIO
} from "../../utils/GameAudioPlayer";
import TextView from "../commons/TextView";
import AppText from "../commons/AppText";

export default class GamePokerView extends React.Component {

    constructor(props) {
        super(props);
        this.items = props.items;
        this.onLose = props.onLose;
        this.onWin = props.onWin;

        this.state = {
            actionDisabled: false,
            inReset: false,
            play: true,
            values: null,
            isWin: false,
            isLose: false,
            isDraw: false,
        };
    }

    componentDidMount() {
        this.showGameFinishDummyView();
    }

    simulatePlay = () => {
      let firstDelay = 0;
      if (this.props.roundsPlayed > 0) {
        firstDelay = 3000;
      }
      setTimeout(() => {
        dispatchSimulationClick(this.refPlay);

        setTimeout(() => {
          const ref1 = this['refTouch1_0'];
          if (ref1) {
            dispatchSimulationClick(ref1);
          }

          setTimeout(() => {
            const ref2 = this['refTouch1_1'];
            if (ref2) {
              dispatchSimulationClick(ref2);
            }

            setTimeout(() => {
              const ref3 = this['refTouch1_2'];
              if (ref3) {
                dispatchSimulationClick(ref3);
              }
            }, 800);
          }, 800);
        }, 5000);
      }, firstDelay);
    }

    resetForPreview(items, previewCardsShow, previewCardsKeyShow) {
      this.items = items;
      this.setState({
        actionDisabled: false,
        inReset: true,
        play: true,
        values: null,
        isWin: false,
        isLose: false,
        isDraw: false,
        hideLoader: false,
      }, () => {
        const values = [];
        let index = 0;
        for (let i = 0; i < 2; i++) {
          const valueArr = [];
          for (let j = 0; j < this.props.columns; j++) {
            index++;
            if (index > this.items.length - 1) {
              index = 0;
            }
            let effIndex = index;
            if (previewCardsKeyShow && i === 1 && j === 0) {
              effIndex = 0;
            }
            valueArr.push({item: this.items[effIndex], value: 0});
          }
          values.push(valueArr);
        }
        this.setState({
          inReset: false,
          values: values
        }, () => {
          let flips = 0;
          for (let i = 0; i < 2; i++) {
            for (let j = 0; j < this.props.columns; j++) {
              if (flips >= previewCardsShow) {
                break;
              }

              const key = i +'_'+ j;
              const refView = this['refCard'+ key];
              if (refView) {
                refView.flip();
              }
              flips++;
            }
          }
        });
      });
    }

    reset(items) {
        const currentTime = new Date().getTime();
        let idleTime = 4 * 1000;
        if (this.props.noActionMode) {
          idleTime = 500;
        }
        const resetAfter = Math.max(0, idleTime - (currentTime - this.endGameProcessStartTime));

        setTimeout(() => {
            this.items = items;
            this.setState({
                actionDisabled: false,
                inReset: true,
                play: true,
                values: null,
                isWin: false,
                isLose: false,
                isDraw: false,
                hideLoader: false,
                isFetching: false,
            }, () => {
                this.setState({
                    inReset: false,
                });
            });
            this.showGameFinishDummyView();
        }, resetAfter);
    }

    showGameFinishDummyView() {
        if (this.props.disabled && (this.props.userWonRounds >= this.props.roundsToWin || this.props.aiWonRounds >= this.props.roundsToWin)) {
            if (this.props.userWonRounds >= this.props.roundsToWin) {
                this.setState({values: [], hideLoader: true});
            } else {
                this.setState({values: [], isLose: true, hideLoader: true});
            }
        } else if (this.props.disabled) {
            this.setState({values: []});
        }
    }

    playGamePlayAudio() {
        if (this.gamePlayAudioId) {
            this.gamePlayAudioId.play();
        }
    }

    playGameCardShuffleAudio() {
        if (this.gameCardShuffleAudioId) {
            this.gameCardShuffleAudioId.play();
        }
    }

    render() {
        if (this.state.inReset) {
            return null;
        }

        const uiConfigs = this.props.uiConfigs;
        const sizeFactor = uiConfigs.sizeFactor;
        const sizeVFactor = uiConfigs.sizeVFactor;
        const isDisabled = this.props.disabled;
        const cardSize = this.getCardSize();
        const cardSpacing = this.getCardSpacing();

        let botTotal = 0;
        let userTotal = 0;
        const isBotDataAvailable = this.state.values && this.state.values.length > 0;
        const isUserDataAvailable = this.state.values && this.state.values.length > 1;
        for (let i = 0; i < this.props.columns; i++) {
            if (isBotDataAvailable) {
                botTotal += parseInt(this.state.values[0][i].value);
            }
            if (isUserDataAvailable) {
                userTotal += parseInt(this.state.values[1][i].value);
            }
        }

        let hintText = null;
        if (!this.state.values) {
            hintText = locString(this.props.autoSimulation ? 'activity.hint1GamePokerAS' : 'hint1GamePoker');
        } else if (this.state.values && this.state.values.length > 1 && this.state.values[1].length === this.props.columns) {
            hintText = locString(this.props.autoSimulation ? 'activity.hint2GamePokerAS' : 'hint2GamePoker');
        }

        return (
            <View style={{alignItems: 'center', paddingBottom: uiConfigs.collectionImage ? 28 * sizeFactor : 0}}>
              {!this.props.disableAudio ?
                <div>
                  <GameAudio ref={(ref) => this.gamePlayAudioId = ref} source={this.props.gamePlayAudioUrl || GAME_PLAY_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                  <GameAudio ref={(ref) => this.gameCardShuffleAudioId = ref} source={GAME_CARD_SHUFFLE_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                  <GameAudio ref={(ref) => this.gamePlayAudioIdLose = ref} source={this.props.gameLoseAudioUrl || GAME_LOSE_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                  <GameAudio ref={(ref) => this.gamePlayAudioIdWin = ref} source={this.props.gameWinAudioUrl || GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                  <GameAudio ref={(ref) => this.gamePlayAudioIdNeutral = ref} source={GAME_NEUTRAL_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                </div>
                :null
              }

                <ImageBackground source={uiConfigs.gameBgTopImage} resizeMode="fill" style={{height: 40 * sizeFactor, minWidth: 180 * sizeFactor, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, marginStart: 8 * sizeFactor, marginEnd: 8 * sizeFactor}}>
                        {locString('roundInfo', {value1: this.props.roundsPlayed, value2: this.props.rounds})}
                    </AppText>
                </ImageBackground>

                <View style={{marginTop: 16 * sizeFactor, position: 'relative'}}>
                    <View style={{opacity: isDisabled ? 0.8 : 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                        <BotCardsView
                          onRef={this.onRef}
                          columns={this.props.columns}
                          uiConfigs={uiConfigs}
                          cardSize={cardSize}
                          cardSpacing={cardSpacing}
                          values={this.state.values}
                          cardImageUrl={this.props.cardImageUrl}
                          onCardFlipStart={this.onCardFlipStart}
                          onCardFlipEnd={this.onCardFlipEnd}
                          onImageClicked={this.props.onImageClicked}
                        />
                    </View>
                    <View style={{flexDirection: 'row', margin: 6 * sizeFactor}}>
                        <RoundsView uiConfigs={uiConfigs} type={0} imageUrl={this.props.aiImageUrl} value={''+ this.props.aiWonRounds} onImageClicked={this.props.onImageClicked} />
                        <View style={{flex: 1}}/>
                        <TotalView uiConfigs={uiConfigs} type={0} value={''+ botTotal} />
                    </View>
                    <View style={{opacity: isDisabled ? 0.8 : 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', marginTop: 8*sizeVFactor, marginBottom: 8*sizeVFactor}}>
                        <TextView
                            fontSizeN={uiConfigs.fontSize}
                            style={{minWidth: 180 * uiConfigs.fontSize/16, color: ColorWhite, fontWeight: FontWeightMedium, textAlign: 'center', marginLeft: (uiConfigs.isLTR ? 60 : 16) * sizeFactor + SpaceNormal, marginRight: (uiConfigs.isLTR ? 16 : 60) * sizeFactor, opacity: hintText ? 1 : 0}}>
                            {hintText}
                        </TextView>
                        <View style={{position: 'relative', width: 54 * sizeFactor, height: 54 * sizeFactor}}>
                          <AppImageButtonEx
                              ref={(ref) => this.refPlay = ref}
                              disabled={isDisabled || this.state.values || this.state.isFetching}
                              onClick={this.onStart}
                              imageSource={uiConfigs.playImage}
                              imageStyle={{width: 54 * sizeFactor, height: 54 * sizeFactor}}
                          />
                          {this.state.isFetching ?
                            <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                              <CircularProgress size={54 * sizeFactor} style={{color: uiConfigs.messageBgColor}}/>
                            </View>
                            : null
                          }
                        </View>
                    </View>
                    <View style={{flexDirection: 'row', alignItems: 'flex-end', margin: 6 * sizeFactor}}>
                        <RoundsView uiConfigs={uiConfigs} type={1} imageUrl={this.props.userImageUrl || require('src/images/img_user_dummy.png')} value={''+ this.props.userWonRounds} onImageClicked={this.props.onImageClicked} />
                        <View style={{flex: 1}}/>
                        <TotalView uiConfigs={uiConfigs} type={1} value={''+ userTotal} />
                    </View>
                    <View style={{opacity: isDisabled ? 0.8 : 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                      <UserCardsView
                        onRef={this.onRef}
                        refTouch={this.onRefTouch}
                        columns={this.props.columns}
                        uiConfigs={uiConfigs}
                        cardSize={cardSize}
                        cardSpacing={cardSpacing}
                        values={this.state.values}
                        cardImageUrl={this.props.cardImageUrl}
                        isDisabled={isDisabled}
                        actionDisabled={this.state.actionDisabled}
                        onFlipClicked={this.onFlipClicked}
                        onCardFlipStart={this.onCardFlipStart}
                        onCardFlipEnd={this.onCardFlipEnd}
                        onImageClicked={this.props.onImageClicked}
                      />
                    </View>

                    {this.state.isDraw || this.state.isWin || this.state.isLose ?
                        <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, justifyContent: 'center', alignItems: 'center'}}>
                            <View style={{alignItems: 'center'}}>
                                <View style={{padding: 8, paddingLeft: 16, paddingRight: 16, backgroundColor: AppUtils.colorWithAlpha(uiConfigs.messageBgColor, 0.9), borderRadius: 20}}>
                                    <AppText align={'center'} fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{color: uiConfigs.overlayTitleColor, fontWeight: FontWeightMedium}}>
                                        {this.state.isDraw ? locString('activity.roundDraw') : (this.state.isWin ? locString(this.props.disabled ? 'youWon' : 'activity.roundWon') : locString(this.props.disabled ? 'youLost' : 'activity.roundLost'))}
                                    </AppText>
                                </View>
                                {!this.props.simulation && !this.state.hideLoader ?
                                    <CircularProgress size={uiConfigs.fontSize * 2} style={{color: uiConfigs.messageBgColor, marginTop: 4}} />
                                    : null
                                }
                            </View>
                        </View>
                        : null
                    }
                </View>
            </View>
        );
    }

    onRefTouch = (ref, key) => {
      this['refTouch'+ key] = ref;
    }

    onRef = (ref, key) => {
      this['refCard'+ key] = ref;
    }

    onFlipClicked = (key) => {
      const refView = this['refCard'+ key];
      if (refView) {
        this['refCard' + key].flip();
      }
    }

    onFetchDone = (gameData) => {
      this.setState({isFetching: false});
      this.gameState = gameData.state;
      this.playGameCardShuffleAudio();
      setTimeout(() => {
        this.setState({values: []});
      }, 200);
      // start animation
      setTimeout(() => {
        const botItems = [];
        for (let i = 0; i < this.props.columns; i++) {
          const itemId = this.gameState[i];
          const item = this.getItemForItemId(itemId);
          botItems.push({
            item,
            value: 0
          });
        }
        this.setState({values: [botItems]});
        setTimeout(() => {
          this.flipAiCards();
        }, 400);
      }, 500);
    }

    onFetchError = () => {
      this.setState({actionDisabled: false, isFetching: false});
    };

    onStart = () => {
      if (this.props.noActionMode) {
        this.props.onActionClickedInNoActionMode();
        return;
      }

      if (!this.state.actionDisabled) {
        if (this.props.onStart) {
          this.props.onStart();
        }

        this.setState({actionDisabled: true, isFetching: true}, () => {
          const input = [];
          this.items.forEach((item) => {
            input.push({id: item.id, val: item.value1});
          });
          const gameData = {
            input: input,
            state: null,
          };
          const fetchAction = this.props.fetchAction;
          if (fetchAction) {
            setTimeout(() => {
              fetchAction({gameData}, this.onFetchDone, this.onFetchError);
            }, 500);
            return;
          }
          this.fetchActionLocal(gameData, this.onFetchDone);
        });
      }
    };

    fetchActionLocal(gameData, onDone) {
      setTimeout(() => {
        const gameState = [];
        const canBotHaveSpecialCard = parseInt((Math.random() * 100)) > 100 - 90;
        const canUserHaveSpecialCard = parseInt((Math.random() * 100)) > 100 - 10;
        for (let i = 0; i < this.props.columns; i++) {
          let randomInt = AppUtils.getRandomInt(this.items.length);
          if (randomInt === 0 && !canBotHaveSpecialCard) {
            randomInt = i > 0 ? i : 1;
          }
          gameState.push(gameData.input[randomInt].id);
        }
        for (let i = 0; i < this.props.columns; i++) {
          let randomInt = AppUtils.getRandomInt(this.items.length);
          if (randomInt === 0 && !canUserHaveSpecialCard) {
            randomInt = i > 0 ? i : 1;
          }
          gameState.push(gameData.input[randomInt].id);
        }
        onDone({
          state: gameState,
          result: 0,
          resultVal: null,
        });
      }, 1000);
    }

    flipAiCards(index = 0) {
        setTimeout(() => {
            const key = 0 +'_'+ index;
            const refView = this['refCard'+ key];
            if (refView) {
                refView.flip();
                index++;

                if (index === this.props.columns) {
                    const userItems = [];
                    for (let i = 0; i < this.props.columns; i++) {
                        const itemId = this.gameState[this.props.columns + i];
                        const item = this.getItemForItemId(itemId);
                        userItems.push({
                            item,
                            value: 0
                        });
                    }
                    this.setState({values: [this.state.values[0], userItems], actionDisabled: false});
                } else {
                    this.flipAiCards(index);
                }
            }
        }, 600);
    }

    onCardFlipStart = (type, item, index) => {
        this.playGamePlayAudio();
    };

    onCardFlipEnd = (type, item, index) => {
        const data = this.state.values[type][index];
        if (data.value > 0) {
            return;
        }

        data.value = item.value1;
        this.setState({values: this.state.values}, () => {
            if (type === 1) {
                this.processGameAction();
            }
        });
    };

    processGameAction() {
        let isGameEnded = true;

        let userScore = 0;
        const userValues = this.state.values[1];
        userValues.forEach((data) => {
            userScore += parseInt(data.value);
            if (data.value === 0) {
                isGameEnded = false;
            }
        });
        if (isGameEnded) {
            let botScore = 0;
            this.state.values[0].forEach((data) => {
                botScore += parseInt(data.value);
            });
            const isWin = userScore > botScore;
            const isLose = userScore < botScore;
            const isDraw = userScore === botScore;
            setTimeout(() => {
                this.processGameEnd(isWin, isLose, isDraw);
                this.setState({isWin: isWin, isLose: isLose, isDraw: isDraw});
            }, 400);
        }
    }

    processGameEnd(isWin, isLose, isDraw) {
        this.endGameProcessStartTime = new Date().getTime();

        if (isDraw) {
          if (this.gamePlayAudioIdNeutral) {
            this.gamePlayAudioIdNeutral.play();
          }
        } else if (isWin) {
            if (this.gamePlayAudioIdWin) {
              this.gamePlayAudioIdWin.play();
            }
        } else {
            if (this.gamePlayAudioIdLose) {
              this.gamePlayAudioIdLose.play();
            }
        }

        // const endGameValue = JSON.stringify({isWin: isWin, isLose: isLose, isDraw: isDraw});
        if (this.props.onEnd) {
            this.props.onEnd({isWin: isWin, isLose: isLose, isDraw: isDraw});
        }
    }

    getItemForItemId(itemId) {
      if (this.items) {
        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];
          if (item.id === itemId) {
            return item;
          }
        }
      }
    }

    getCardSize() {
        const uiConfigs = this.props.uiConfigs;
        const sizeFactor = uiConfigs.sizeFactor;
        const cardSpacing = this.getCardSpacing();

        const rows = this.props.rows;
        const columns = this.props.columns;
        const borderWidth = 40 * sizeFactor;
        const borderHeight = 36 * sizeFactor;
        const otherUiHeight = 200 * sizeFactor;

        const possibleWidth = (this.props.contentWidth - 2 - (borderWidth * sizeFactor) - (columns - 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
        const possibleHeight = (this.props.contentHeight - otherUiHeight - 2 - (borderHeight * sizeFactor) - (rows - 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card
        const possibleSize = Math.min(possibleWidth, possibleHeight);
        const maxCardSize = this.props.maxCardSize || 200;
        const cardSize = Math.floor(Math.min(maxCardSize, possibleSize));
        return cardSize;
    }

    getCardSpacing() {
        return 4;
    }
}

const BotCardsView = React.memo((props) => {
  const {uiConfigs, cardSize, cardSpacing, columns, cardImageUrl, values,
    onRef, onCardFlipStart, onCardFlipEnd, onImageClicked} = props;

  const botCardViews = [];
  const isBotDataAvailable = values && values.length > 0;
  for (let i = 0; i < columns; i++) {
    let botDataL = null;
    let botItemL = null;
    let botValueL = null;
    if (isBotDataAvailable) {
      botDataL = values[0][i];
      botItemL = botDataL.item;
      botValueL = botDataL.value;
    }
    botCardViews.push(
      <CardView
        onRef={onRef}
        uiConfigs={uiConfigs}
        cardSize={cardSize}
        cardSpacing={cardSpacing}
        type={0}
        item={botItemL}
        value={botValueL}
        index={i}
        values={values}
        cardImageUrl={cardImageUrl}
        isDisabled={true}
        actionDisabled={true}
        onCardFlipStart={onCardFlipStart}
        onCardFlipEnd={onCardFlipEnd}
        onImageClicked={onImageClicked}
      />
    );
  }
  return botCardViews;
});

const UserCardsView = React.memo((props) => {
  const {uiConfigs, cardSize, cardSpacing, columns, cardImageUrl, values, isDisabled, actionDisabled,
    onRef, refTouch, onFlipClicked, onCardFlipStart, onCardFlipEnd, onImageClicked} = props;

  const userCardViews = [];
  const isUserDataAvailable = values && values.length > 1;
  for (let i = 0; i < columns; i++) {
    let userDataL = null;
    let userItemL = null;
    let userValueL = null;
    if (isUserDataAvailable) {
      userDataL = values[1][i];
      userItemL = userDataL.item;
      userValueL = userDataL.value;
    }
    userCardViews.push(
      <CardView
        onRef={onRef}
        refTouch={refTouch}
        uiConfigs={uiConfigs}
        cardSize={cardSize}
        cardSpacing={cardSpacing}
        type={1}
        item={userItemL}
        value={userValueL}
        index={i}
        values={values}
        cardImageUrl={cardImageUrl}
        isDisabled={isDisabled}
        actionDisabled={actionDisabled}
        onFlipClicked={onFlipClicked}
        onCardFlipStart={onCardFlipStart}
        onCardFlipEnd={onCardFlipEnd}
        onImageClicked={onImageClicked}
      />
    );
  }
  return userCardViews;
});

const CardView = React.memo((props) => {
  const {uiConfigs, cardSize, cardSpacing, type, item, value, index, values, cardImageUrl, isDisabled, actionDisabled,
    onRef, refTouch, onFlipClicked, onCardFlipStart, onCardFlipEnd, onImageClicked} = props;

  const sizeFactor = uiConfigs.sizeFactor;
  const touchDisabled = isDisabled || actionDisabled || type === 0 || !item || value > 0;
  const key = type +'_'+ index;

  const onCardFlipStartL = () => {
    onCardFlipStart(type, item, index);
  };

  const onCardFlipEndL = () => {
    onCardFlipEnd(type, item, index);
  };

  const onImageClickedL = () => {
    onImageClicked(item.imageUrl);
  };

  const onFlipClickedL = () => {
    if (onFlipClicked) {
      onFlipClicked(key);
    }
  };

  const onRefL = (ref) => {
    onRef(ref, key);
  };

  const refTouchL = (ref) => {
    if (refTouch) {
      refTouch(ref, key);
    }
  };

  const cardImageWidth = cardSize < 120 ? cardSize-36*sizeFactor : cardSize-48;
  const cardImageHeight = cardSize < 120 ? cardSize-50*sizeFactor : cardSize-68;

  return (
    <View>
      <CardFlipView
        key={key}
        style={{margin: cardSpacing / 2, width: cardSize, height: cardSize, alignItems: 'center', justifyContent: 'center', opacity: isDisabled ? 0.7 : 1}}
        onFlipStart={onCardFlipStartL}
        onFlipEnd={onCardFlipEndL}
        ref={onRefL}>
        <TouchableOpacity
          ref={refTouchL}
          disabled={touchDisabled}
          onClick={onFlipClickedL}
          style={{width: cardSize, height: cardSize}} >
          <View style={{width: cardSize, height: cardSize}}>
            <ImageBackground source={uiConfigs.cardBg1Image} resizeMode="fill" style={{width: cardSize, height: cardSize, opacity: values ? 1 : 0, display: 'flex'}}>
              {values && cardImageUrl ?
                <View style={{position: 'relative', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                  <AppImage resizeMode={'cover'} source={cardImageUrl} style={{width: cardImageWidth, height: cardImageHeight, borderRadius: 4, marginBottom: 2*sizeFactor, backgroundColor: '#FF0000'}}/>
                </View>
                : null
              }
            </ImageBackground>
          </View>
        </TouchableOpacity>
        <ImageBackground source={uiConfigs.cardBgImage} resizeMode="fill" style={{width: cardSize, height: cardSize, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          {item ?
            <TouchableOpacity onClick={onImageClickedL} style={{position: 'relative'}}>
              <AppImage
                style={{
                  width: cardSize-14*sizeFactor,
                  height: cardSize-8*sizeFactor,
                  borderRadius: RadiusView
                }}
                imageUrl={item.imageUrl}
              />
            </TouchableOpacity>
            : null
          }
        </ImageBackground>
      </CardFlipView>
      {/*{type === 1 ?*/}
      {/*  <View style={{opacity: value > 0 ? 1 : 0, flexDirection: 'row', justifyContent: 'center'}}>*/}
      {/*    <ImageBackground key={'I'+ type +'_'+ index} source={uiConfigs.gameIValueBgImage} resizeMode="fill" style={{height: 28 * sizeFactor, minWidth: 44 * sizeFactor, alignItems: 'center', justifyContent: 'center', paddingBottom: 2 * sizeFactor}}>*/}
      {/*      <AppText fontSizeN={uiConfigs.fontSize} variant={'body2'} style={{position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, marginLeft: 8, marginRight: 8, marginTop: 2}}>*/}
      {/*        {value}*/}
      {/*      </AppText>*/}
      {/*    </ImageBackground>*/}
      {/*  </View>*/}
      {/*  : null*/}
      {/*}*/}
    </View>
  );
});

const TotalView = React.memo((props) => {
  const {uiConfigs, type, value} = props;
  const sizeFactor = uiConfigs.sizeFactor;

  return (
    <ImageBackground key={'S'+ type} source={uiConfigs.otherActionImage} resizeMode="fill" style={{height: 32 * sizeFactor, minWidth: 56 * sizeFactor, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom: 4 * sizeFactor, opacity: value > 0 ? 1 : 0}}>
      <AppText fontSizeN={uiConfigs.fontSize} style={{position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, marginLeft: 8, marginRight: 8}}>
        {value}
      </AppText>
    </ImageBackground>
  );
});

const RoundsView = React.memo((props) => {
  const {uiConfigs, type, imageUrl, value, onImageClicked} = props;
  const sizeFactor = uiConfigs.sizeFactor;

  const onImageClickedL = () => {
    onImageClicked(imageUrl);
  }

  return (
    <View key={'R'+ type} style={{flexDirection: 'row', height: 48 * sizeFactor, minWidth: 160 * sizeFactor, alignItems: 'center'}} >
      <ImageBackground source={uiConfigs.gameUserScoreImage} resizeMode="fill" style={{height: 50 * sizeFactor, width: 48 * sizeFactor, paddingBottom: 2 * sizeFactor, display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1}} >
        <TouchableOpacity onClick={onImageClickedL}>
          <AppImage imageUrl={imageUrl} style={{width: 42 * sizeFactor, height: 42 * sizeFactor, borderRadius: 4}}/>
        </TouchableOpacity>
      </ImageBackground>
      <ImageBackground source={uiConfigs.gameScoreImage} style={{height: 32 * sizeFactor, minWidth: 56 * sizeFactor, marginLeft: 4, marginRight: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 2 * sizeFactor}} >
        <AppText fontSizeN={uiConfigs.fontSize} style={{position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, textAlign: 'center'}}>
          {value}
        </AppText>
      </ImageBackground>
    </View>
  );
});
